import * as React from 'react';

export const Tabs: React.FunctionComponent = ({ children }) => (
	<div className='mt-4 px-4'>
		<div className='px-4 w-full h-full'>
			<div className='flex flex-row justify-start border-b border-gray-200 gap-4'>{children}</div>
		</div>
	</div>
);

Tabs.displayName = 'UI.Tabs';

export const Tab: React.FunctionComponent<{
	isSelected: boolean;
}> = ({ children, isSelected }) => (
	<div
		className={`block relative container w-auto text-center px-6 py-4 text-base text-center cursor-pointer hover:text-cogvio-700 ${
			isSelected ? 'text-cogvio-700' : 'text-gray-500'
		}`}
	>
		{children}
		{isSelected ? <div className='absolute bottom-0 left-0 h-px w-full border-b-2 border-cogvio-700' /> : null}
	</div>
);

Tab.displayName = 'UI.Tab';
